<template>
  <div>
    <a-card :bordered="false">
      <div class="account-box">
        <a @click="() => (accountModal.visible = true)">添加收款账户</a>
      </div>
      <a-list :data-source="accountList" item-layout="horizontal">
        <a-list-item slot="renderItem" slot-scope="item, index" :key="index">
          <a-list-item-meta>
            <a slot="title">
              <span style="margin-right: 10px;">{{ item.accountType }}</span>
              <a-tag
                class="render-tag"
                color="#108ee9"
                v-if="item.isDefault == 'T'"
                >默认账户</a-tag
              >
            </a>
            <div slot="description">
              <span style="color: #000000;">账户名:</span>
              <span style="padding: 0 5px;">{{ item.accountName }}</span>
              <span style="color: #000000;margin-left: 10px;">账号:</span>
              <span style="padding: 0 5px;">{{ item.accountNo }}</span>
            </div>
          </a-list-item-meta>
          <div class="opt">
            <a @click="action(item, index, 'modify')">编辑</a>
            <a @click="action(item, index, 'del')">删除</a>
            <a
              v-if="item.isDefault == 'F'"
              @click="action(item, index, 'default')"
              >设置默认账户</a
            >
          </div>
        </a-list-item>
      </a-list>

      <div class="operation">
        <a-popconfirm
          title="确认保存?"
          @confirm="save"
          okText="确认"
          cancelText="取消"
        >
          <a-button type="primary" :loading="loading">保存</a-button>
        </a-popconfirm>
      </div>

      <div class="tips">
        <p>提示：添加、编辑、删除、设置默认账户操作后必须点击"保存"才可生效</p>
      </div>
    </a-card>

    <a-modal
      v-model="accountModal.visible"
      title="添加收款账户"
      @ok="handleOk"
      @cancel="cancel"
    >
      <a-form-model
        ref="accountForm"
        :rules="formAccountRules"
        :model="formAccount"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item label="账户类型" prop="accountType">
          <a-select
            v-model="formAccount.accountType"
            placeholder="请选择账户类型"
          >
            <a-select-option
              v-for="item in accountTypeList"
              :value="item.value"
              :key="item.value"
              >{{ item.name }}({{ item.value }})</a-select-option
            >
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="账户名称" prop="accountName"
          ><a-input
            v-model="formAccount.accountName"
            placeholder="请输入账户名称"
        /></a-form-model-item>

        <a-form-model-item label="账户号" prop="accountNo"
          ><a-input v-model="formAccount.accountNo" placeholder="请输入账户号"
        /></a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: "MerchantAccount",
  data() {
    return {
      loading: false,
      userInfo: null,
      merchantNo: "", // 商户编号
      accountList: [], //商户账户信息
      accountTypeList: [
        { name: "银行卡", value: "BANK" },
        { name: "微信", value: "WEIXIN" },
        { name: "支付宝", value: "ALIPAY" }
      ],
      accountModal: {
        visible: false
      },
      formAccount: {
        merchantNo: "",
        accountType: undefined, //账户类型
        accountName: "", //账户名称
        accountNo: "", //账户号
        isDefault: "F"
      },
      formAccountRules: {
        accountType: [{ required: true, message: "请选择账户类型" }],
        accountName: [{ required: true, message: "请输入账户名称" }],
        accountNo: [{ required: true, message: "请输入账户号" }]
      },
      accountIndex: -1,
      deleteAccountList: []
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
    this.merchantNo = this.userInfo.merchantNo;
    this.getMerchantAccount();
  },
  methods: {
    async getMerchantAccount() {
      this.$http.roomBksApi
        .findMerchantAccoutByMerchantNo({ merchantNo: this.merchantNo })
        .then(res => {
          if (res && res.result == 0) {
            this.accountList = res.resultObject;
          }
        });
    },
    action(item, index, type) {
      this.accountIndex = index;
      if (type == "modify") {
        this.formAccount = Object.assign({}, item);
        this.accountModal.visible = true;
      } else if (type == "del") {
        this.accountList.splice(index, 1);
        if (item.id) {
          item.isDelete = "T";
          this.deleteAccountList.push(item);
        }
      } else if (type == "default") {
        for (let i = 0; i < this.accountList.length; i++) {
          if (index == i) {
            this.accountList[i].isDefault = "T";
          } else {
            this.accountList[i].isDefault = "F";
          }
        }
      }
    },
    handleOk() {
      this.$refs.accountForm.validate(valid => {
        if (valid) {
          let obj = Object.assign({}, this.formAccount);
          if (this.accountIndex == -1) {
            obj.merchantNo = this.merchantNo;
            let flag = true;
            for (let cur of this.accountList) {
              if (
                obj.accountType == cur.accountType &&
                obj.accountNo == cur.accountNo
              ) {
                flag = false;
                break;
              }
            }
            if (flag) {
              this.accountList.push(obj);
              this.cancel();
            } else {
              this.$message.info("收款账户已存在");
            }
          } else {
            this.accountList.splice(this.accountIndex, 1, obj);
            this.cancel();
          }
        }
      });
    },
    cancel() {
      this.$refs.accountForm.resetFields();
      this.accountModal.visible = false;
      this.accountIndex = -1;
    },

    save() {
      let param = {};
      if (this.accountList.length == 0) {
        this.$message.info("请添加收款账户");
        return;
      }
      let flag = false;
      for (let obj of this.accountList) {
        if (obj.isDefault == "T") {
          flag = true;
          break;
        }
      }
      if (!flag) {
        this.$message.info("请设置默认账户");
        return;
      }
      param.merchantAccountList = this.accountList.concat(
        this.deleteAccountList
      );
      this.loading = true;
      this.$http.roomBksApi
        .saveMerchantAccount(param)
        .then(res => {
          if (res && res.result == 0) {
            this.$message.success(res.msg);
            this.getMerchantAccount();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.opt {
  a {
    margin: 0 5px;
  }
}

.operation {
  text-align: center;
  margin: 20px auto 5px;
  button {
    margin: 0 10px;
  }
}
.tips {
  margin-top: 20px;
  color: red;
}
</style>
